import AppDataService from "./AppDataService";

export default class NotificationService {
  static async clearAllNotification(id) {
    return await AppDataService.patch(`notification/clear/all/${id}`, {});
  }
  static async patchVerifyOrderStatus(id, data) {
    return await AppDataService.patch(`order/${id}`, data);
  }
  static async deleteNotification(id) {
    return await AppDataService.patch(`notification/clear/${id}`, {});
  }
}
